
class SoundEvent {
  /**
  * SoundEvent class constructor  
  * @constructor
  * @param {String} id - sound id
  * @param {Number} time
  **/
  constructor(id, time) {
    this.id = id
    this.time = time
  }
}

export default SoundEvent